function getType(target) {
  return Object.prototype.toString.call(target);
}
function isNumber(v) {
  return getType(v) === "[object Number]";
}
function isString(v) {
  return typeof v === "string";
}
function isConvertibleNumber(v) {
  return (isNumber(v) || isString(v)) && !Number.isNaN(Number(v));
}
function isNonEmptyString(v) {
  return typeof v === "string" && v.length > 0;
}
function isEmptyString(v) {
  return typeof v === "string" && v.length === 0;
}
function isNonBlankString(v) {
  return typeof v === "string" && v.trim().length > 0;
}
function isBlankString(v) {
  return typeof v === "string" && v.trim().length === 0;
}
const isFloat = Number.isFinite;
const isNaN = Number.isNaN;
function isInfinite(v) {
  return v === Number.NEGATIVE_INFINITY || v === Number.POSITIVE_INFINITY;
}
const isInteger = Number.isInteger;
const isSafeInteger = Number.isSafeInteger;
function isBoolean(v) {
  return v === true || v === false;
}
function isRegexp(v) {
  return getType(v) === "[object RegExp]";
}
function isSet(v) {
  return getType(v) === "[object Set]";
}
function isMap(v) {
  return getType(v) === "[object Map]";
}
function isRawObject(v) {
  return v !== null && typeof v === "object" && !Array.isArray(v);
}
function isEmptyObject(v) {
  return isRawObject(v) && Object.entries(v).length === 0;
}
function isUndefined(v) {
  return v === void 0;
}
function isNull(v) {
  return v === null;
}
const isArray = Array.isArray;
function isNonEmptyArray(v) {
  return isArray(v) && v.length > 0;
}
function isEmptyArray(v) {
  return isArray(v) && v.length === 0;
}
function isTypedArray(v, assert) {
  return isArray(v) && v.every(assert);
}
function isOmitable(v, assert) {
  return v === void 0 || v === null || assert(v);
}
function isOmitted(v) {
  return v === void 0 || v === null;
}
function isFunction(v) {
  return typeof v === "function" && !v.toString().startsWith("class");
}
function isBigInt(v) {
  return typeof v === "bigint";
}
function isSymbol(v) {
  return typeof v === "symbol";
}
const REGEXP_IS_INTEGER = /^(-|\+)?([1-9]\d*|0)$/;
const REGEXP_IS_INTEGER_WITH_LEADING_ZERO = /^(-|\+)?\d+$/;
function isIntegerString(input, allowLeading0 = false) {
  return typeof input === "string" && (allowLeading0 ? REGEXP_IS_INTEGER_WITH_LEADING_ZERO : REGEXP_IS_INTEGER).test(input);
}
const floatStringRegExpCache = {};
const REGEXP_IS_REAL_NUMBER = /^(-|\+)?([1-9]\d*|0)(\.\d+)?$/;
const REGEXP_IS_REAL_NUMBER_WITH_LEADING_ZERO = /^(-|\+)?\d+(\.\d+)?$/;
function isFloatString(input, maxAcc = null, minAcc = null, allowLeading0 = false) {
  if (typeof input !== "string") {
    return false;
  }
  if (!isSafeInteger(maxAcc)) {
    return (allowLeading0 ? REGEXP_IS_REAL_NUMBER_WITH_LEADING_ZERO : REGEXP_IS_REAL_NUMBER).test(input);
  }
  if (maxAcc <= 0) {
    return isIntegerString(input, allowLeading0);
  }
  minAcc ?? (minAcc = maxAcc ?? 0);
  if (!isSafeInteger(minAcc) || minAcc < 0) {
    minAcc = 0;
  }
  if (maxAcc < minAcc) {
    minAcc = maxAcc;
  }
  const pFloat = minAcc === maxAcc ? `\\.\\d{${minAcc}}` : minAcc === 0 ? `(\\.\\d{1,${maxAcc}})?` : `\\.\\d{${minAcc},${maxAcc}}`;
  const pInt = allowLeading0 ? "\\d+" : "([1-9]\\d*|0)";
  const re = `^(-|\\+)?${pInt}${pFloat}$`;
  if (!floatStringRegExpCache[re]) {
    floatStringRegExpCache[re] = new RegExp(re);
  }
  return floatStringRegExpCache[re].test(input);
}
export {
  getType,
  isArray,
  isBigInt,
  isBlankString,
  isBoolean,
  isConvertibleNumber,
  isEmptyArray,
  isEmptyObject,
  isEmptyString,
  isFloat,
  isFloatString,
  isFunction,
  isInfinite,
  isInteger,
  isIntegerString,
  isMap,
  isNaN,
  isNonBlankString,
  isNonEmptyArray,
  isNonEmptyString,
  isNull,
  isNumber,
  isOmitable,
  isOmitted,
  isRawObject,
  isRegexp,
  isSafeInteger,
  isSet,
  isString,
  isSymbol,
  isTypedArray,
  isUndefined
};
//# sourceMappingURL=TypeAssert.js.map
